import React, { useImperativeHandle, forwardRef, useRef } from 'react';
import { useRefresh } from 'react-admin';

import { DialogoConfirmacao } from '../../../Components';
import { api } from '../../../services';

const FormDialog = forwardRef(({ campoAtivo }, ref) => {
  const refresh = useRefresh();
  const refDialogoConfirmacao = useRef(null);

  useImperativeHandle(ref, () => ({
    handleOpen(record) {
      if (refDialogoConfirmacao.current) {
        refDialogoConfirmacao.current.handleOpen(
          'Marcar como Verificado',
          'Tem certeza da modificação do status desse recurso',
          record,
        );
      }
    },
  }));

  async function handleConfirma(id) {
    await api.put(`/financeiro_transferencias/confirmar/${id}`);
    refresh();
  }

  return (
    <DialogoConfirmacao
      ref={refDialogoConfirmacao}
      handleConfirma={handleConfirma}
    />
  );
});

export default FormDialog;
